import { useEffect, useState } from "react";
import { io, Socket } from "socket.io-client";

function getVehicleKey(vehicle: any) {
  return String(vehicle?.vehicleId || vehicle?.uniqueId || "");
}

export function useWarRoomSocket() {
  const [vehicles, setVehicles] = useState<any[]>([]);

  useEffect(() => {
    const socket: Socket = io('https://dashboard.ev91riderz.com', {
       path: "/socket.io",
       transports: ["websocket", "polling"],
       secure: true,
       reconnection: true,
       reconnectionDelay: 1000,
       reconnectionDelayMax: 5000,
       reconnectionAttempts: 5,
       rejectUnauthorized: false,
});

    socket.on("connect", () => {
      console.log("🟢 Connected to War Room socket:", socket.id);
    });

    // Unified handler for all vehicle data events
    const handleVehicleData = (data: any[]) => {
      console.log("[DEBUG] Received vehicle data from socket:", data);
      const vehicleMap = new Map<string, any>();

      data.forEach((v) => {
        const lat = Number(v.lat);
        const lng = Number(v.lng);

        if (!Number.isFinite(lat) || !Number.isFinite(lng)) return;

        const uniqueId = getVehicleKey(v);
        if (!uniqueId) return;

        vehicleMap.set(uniqueId, {
          ...v,
          uniqueId,
          lat,
          lng,
        });
      });

setVehicles((prev) => {
  const prevEntries: Array<[string, any]> = prev
    .map((v): [string, any] => [getVehicleKey(v), v])
    .filter(([key]) => Boolean(key));
  const prevMap = new Map<string, any>(prevEntries);

  vehicleMap.forEach((v, key) => {
    prevMap.set(key, v);
  });

  return Array.from(prevMap.values());
});    };

    socket.on("WAR_ROOM_INIT", handleVehicleData);
    socket.on("WAR_ROOM_UPDATE", handleVehicleData);
    socket.on("vehicle-location-update", handleVehicleData);

    return () => {
      socket.off("WAR_ROOM_INIT", handleVehicleData);
      socket.off("WAR_ROOM_UPDATE", handleVehicleData);
      socket.off("vehicle-location-update", handleVehicleData);
      socket.disconnect();
    };
    
  }, []);

  return vehicles;
}
